import React from 'react'
import parser from 'html-react-parser'

export default function Content12({ data }) {
    const { content12LeftList, content12RightList, content12Text, content12Title } = data
    return (
        <div className='dana-sec-3 panel-space-70'>
            <div className='container'>
                <div className='row heading-head-sec'>
                    <div className='col-md-4'>
                        <div className='heading-level-2 blue-color'>
                            {content12Title && parser(content12Title)}
                        </div>
                    </div>
                    <div className='col-md-8'>
                        <p>
                            <strong>{content12Text && parser(content12Text)}</strong>
                        </p>
                    </div>
                </div>
                <div className='row yellow-dot-list'>
                    <div className='col-md-6'>{content12LeftList && parser(content12LeftList)}</div>
                    <div className='col-md-6'>{content12RightList && parser(content12RightList)}</div>
                </div>
            </div>
        </div>
    )
}
